
import { useEffect } from "react";
import { UseWidgetDefinitionsResult } from "./types";
import { useWidgetOperations } from "./useWidgetOperations";
import { useWidgetQueries } from "./useWidgetQueries";
import { useWidgetUtils } from "./useWidgetUtils";

// This hook will manage the widget definitions by composing other hooks
export function useWidgetDefinitions(): UseWidgetDefinitionsResult {
  const {
    definitions,
    isLoading,
    initializeDefaultWidgets,
    fetchWidgetDefinitions,
    createWidgetDefinition,
    updateWidgetDefinition,
    deleteWidgetDefinition,
    toggleWidgetActive
  } = useWidgetOperations();
  
  const { availableQueries, getAvailableDatabaseQueries, testQuery } = useWidgetQueries();
  const { getWidgetsByDashboardType } = useWidgetUtils(definitions);

  // Initial fetch of widget definitions
  useEffect(() => {
    fetchWidgetDefinitions();
  }, [fetchWidgetDefinitions]);

  return {
    definitions,
    isLoading,
    availableQueries,
    fetchWidgetDefinitions,
    initializeDefaultWidgets,
    createWidgetDefinition,
    updateWidgetDefinition,
    deleteWidgetDefinition,
    toggleWidgetActive,
    getWidgetsByDashboardType,
    getAvailableDatabaseQueries,
    testQuery
  };
}
